export enum AttachmentId {
    EnergyMeterReadingAsset = 'energy-meter-reading-asset',
    EnergyDocumentAsset = 'energy-document-asset',
    WaterTransferAsset = 'water-transfer-asset',
    EnergyDocumentSummary = 'energy-document-summary',
}
